module.exports = __webpack_public_path__ + "img/album22_05.56ba5bdb.jpg";